import React from 'react';
import {
	getWorkOrderBasePriorityBackgroundColor,
	getWorkOrderBasePriorityPillBackgroundColor,
} from '../../../utils/DataFormatterUtils';

const TSPriorityDisplay = ({ priority }) => {
	return (
		<div className="flex whitespace-nowrap leading-normal">
			<span
				style={{
					color: getWorkOrderBasePriorityBackgroundColor(priority),
					backgroundColor: getWorkOrderBasePriorityPillBackgroundColor(priority),
					padding: '4px 12px',
					borderRadius: 16,
				}}
			>
				{priority.name}
			</span>
		</div>
	);
};

export default TSPriorityDisplay;
